import { render, staticRenderFns } from "./TheProduct.vue?vue&type=template&id=d8510b76&"
import script from "./TheProduct.vue?vue&type=script&lang=js&"
export * from "./TheProduct.vue?vue&type=script&lang=js&"
import style0 from "./TheProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports